import { get } from 'lodash';

import { useNavigation } from 'pages/Teachers/StudentPortfolio/utils.js';

const PortfolioNavigation = ({ student, onTitleClick }) => {
  useNavigation({
    studentName: get(student, 'name'),
    onTitleClick: onTitleClick
  });

  return null;
};

export default PortfolioNavigation;
